import styles from "./Shorts.module.scss"
import "video.js/dist/video-js.min.css"
import "vod/components/Vod.scss"

import React, { useEffect } from "react"

import { FullMode, Header, VodFooter } from "@shared/components"
import { PaymentInformation, useLayerPopupContext } from "@shared/contexts"
import { isWindow7 } from "@shared/modules"

import { QuickMenu } from "live/components"
// import { EventPopup } from "live/components/eventPopup"
import Messages from "vod/components/Messages"
import VideoPlayer from "vod/components/Player"
import ProductIframe from "vod/components/ProductIframe"
import { useVodPlayer } from "vod/contexts"

import ShortsAiSummary from "./ShortsAiSummary"

export default function Shorts() {
  const vodPlayer = useVodPlayer()

  // const { schedule } = useSchedule()
  const { open } = useLayerPopupContext()

  // const isFlash = getParam("player_type") === "flash" || isWindow7
  // 밑에 쓰는지 확실하지 않아서 주석처리
  // const isNotPaidSchedule =
  //   !!schedule?.paymentInformation &&
  //   PAYMENT_INFORMATION_WHITE_LIST.includes(schedule.paymentInformation)

  useEffect(() => {
    if (!isWindow7) return

    open("INSTALL_CHROME")
  }, [open])

  return (
    <section className="vodWrap">
      <Header right={<FullMode player={vodPlayer} />} />
      {/* 숏폼은 host/path 정보가 없어 플래시 재생이 불가능해서 항상 신버전 플레이어만 사용.
          윈도우7은 설치 안내 팝업만 띄우고 플레이어는 아예 띄우지 않음 */}
      {!isWindow7 && <VideoPlayer />}
      <VodFooter />
      <article className="sideB">
        <ProductIframe />
        <div className={`contB ${styles.fullContB}`}>
          <Messages isContinueMessage />{" "}
          {/* 숏폼에서는 VOD처럼 녹화리스트가 없어서 그냥 명시적 true로만 넘겨줌 */}
        </div>
        <ShortsAiSummary />
      </article>
      <QuickMenu />

      {/* {isNotPaidSchedule && <EventPopup />} */}
    </section>
  )
}

// const PAYMENT_INFORMATION_WHITE_LIST: PaymentInformation[] = ["ALL", "FREE"]
